import { AuthService } from "../auth/auth.service";

export function AuthenticationFactory(authService: AuthService) {
    return () => {
        if (!authService.isAuthenticated()) {
            authService.initAnonymousSettings();
            return true;
        }

        return authService.loadUserData()
            .then(() => true,
                () => false);
    };
}
